
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref040"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref040"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRequire("kAAOE");

var $3ngNe = parcelRequire("3ngNe");

var $62Vkp = parcelRequire("62Vkp");
const $bc751a32914b011c$var$descriptor = {
    name: {
        type: "string",
        required: true
    },
    email: [
        {
            type: "string",
            required: true
        },
        {
            type: "string",
            message: "Please enter a valid email address",
            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        }
    ],
    message: {
        type: "string",
        required: true
    }
};
const $bc751a32914b011c$var$validator = new (0, $62Vkp.default)($bc751a32914b011c$var$descriptor);
const $bc751a32914b011c$var$submit = (form)=>$bc751a32914b011c$var$validatorFields(form, ()=>{
    // success callback
    });
const $bc751a32914b011c$var$validatorFields = (form, success)=>{
    const { name: name, email: email, message: message } = form;
    $bc751a32914b011c$var$validator.validate({
        name: name,
        email: email,
        message: message
    }).then(()=>{
        success?.({
            name: name,
            email: email,
            message: message
        });
        return true;
    }).catch(({ errors: errors, fields: fields })=>{
        form.errors = errors;
        form.fields = fields;
        return false;
    });
};
(0, $3ngNe.default).data("submit", $bc751a32914b011c$var$submit);
(0, $3ngNe.default).data("errors", null);
(0, $3ngNe.default).data("fields", null);
(0, $3ngNe.default).data("validatorFields", $bc751a32914b011c$var$validatorFields);
(0, $3ngNe.default).start();


//# sourceMappingURL=index.0f601e2e.js.map
